<div class="content">
  <div class="page-title">
    <h1>Engineer Management</h1>

    <div class="add" (click)="add()">
      <i class="fa fa-plus" aria-hidden="true"></i>
    </div>
  </div>


  <div class="card">
    <form class="card-title" (submit)="rebind()">
      <h3><i class="fa fa-search" aria-hidden="true"></i> Search Filters</h3>
      <div class="row buffer-bottom">
        <div class="col-md-3 col-sm-6">
          <label>Name</label>
          <input type="text" class="form-control" name="name" [(ngModel)]="filter.name" />
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">
          <input type="submit" class="btn btn-primary" value="Refresh" />
          <button (click)="resetFilters()" value="Reset" class="btn reset-data">Reset</button>
          <!--<input type="button" value="Export" class="pull-right btn btn-primary" (click)="generateExcel()" />-->
        </div>
      </div>

    </form>
  </div>

  <app-loading-icon *ngIf="loading"></app-loading-icon>

  <div style="display: flex; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: flex-start; width: 100%;;">

    <div style="flex: 8; width: 100%;">
      <div class="header">
        <div style="display: flex; width: 100%; flex-direction: row; flex-wrap: nowrap; justify-content: space-between; align-items: center; ">
          <div class="card custom-card" style="border-color: #D9E5D6; margin-right: 0.5%; ">
            Licenses Used
            <br />
            <h3><b>{{activeUsers}}</b></h3>
          </div>

          <div class="card custom-card" style="border-color: #0E8AB0; margin-left: 0.5%; margin-right: 0.5%">
            Licenses Remaining
            <br />
            <h3><b>{{expiredUsers}}</b></h3>
          </div>

          <!--<div class="card custom-card" style="border-color: #0E8AB0; margin-left: 0.5%; margin-right: 0.5%">
            Expired Licenses
            <br />
            <h3><b>{{expiredUsers}}</b></h3>
          </div>-->

          <div class="card custom-card" style="border-color: #EDDEA4; margin-left: 0.5%; ">
            Total Licenses
            <br />
            <h3><b>{{licenseCount}}</b></h3>
          </div>


        </div>
      </div>
    </div>

  </div>

  <ngx-datatable class="material" [rows]="rows" [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" *ngIf="!loading"
                 [rowHeight]="'auto'" [limit]="10">

    <ngx-datatable-column name="Firstname" prop="firstname">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Surname" prop="surname">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Credentials" prop="credentials">
      <ng-template let-value="value" ngx-datatable-cell-template>
        <div>{{ value }}</div>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Option">
      <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
        <a [routerLink]="['/engineers/manage', row.id]">Edit</a>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>

</div>
